import { Skeleton } from "@/components/atoms/Skeleton/skeleton"
import { FacetsContent } from "./facets-content"

interface FacetsDesktopProps {
  independentFacetDistribution: Record<string, any> | undefined
  facetDistribution: Record<string, any> | Record<string, any> | undefined
  className?: string
  currentFilters: any
  disabledFacets?: string[]
  onFilterChange(newFilters: Partial<Record<string, any>>): void
}

export function FacetsDesktop({
  facetDistribution,
  className,
  disabledFacets,
  onFilterChange,
  currentFilters,
}: FacetsDesktopProps) {
  return (
    <FacetsContent
      facetDistribution={facetDistribution}
      className={className}
      disabledFacets={disabledFacets}
      currentFilters={currentFilters}
      onFilterChange={onFilterChange}
    />
  )
}

export function FacetsContentSkeleton() {
  return (
    <div className="my-8 hidden flex-col gap-0 md:flex">
      <Skeleton className="h-[517px] min-w-[300px] md:block" />
      <Skeleton className="mb-[50px] mt-[72px] h-[394px] min-w-[300px] md:block" />
      <Skeleton className="mb-6 flex h-[35px] min-w-[300px] md:block" />
      <Skeleton className="flex h-[400px] min-w-[300px] md:block" />
    </div>
  )
}
